import React, { Component, PropTypes } from 'react';

const SOCIAL_URLS = {
  twitter: 'https://twitter.com/',
  behance: 'https://behance.net/',
  dribbble: 'https://dribbble.com/',
  facebook: 'https://facebook.com/',
  linkedin: 'https://linkedin.com/in/'
}

const SocialLink = ({ user, name }) => {
  if (!user) {
    return null;
  }

  return (<p>
            <a className="social-link" href={`${SOCIAL_URLS[name]}${user}`} target="_blank">
              <i className={`fa fa-${name}`} /> { name }
            </a>
          </p>
        );
};

export default class Social extends Component {

  render() {
    const {
      twitter, behance, dribbble, facebook, linkedin
    } = this.props;

    if (!twitter && !behance && !dribbble && !facebook && !linkedin) {
      return null;
    }

    return (
            <div className="profile-social">
              <h4>Connect</h4>
              <SocialLink user={twitter} name="twitter" />
              <SocialLink user={behance} name="behance" />
              <SocialLink user={dribbble} name="dribbble" />
              <SocialLink user={facebook} name="facebook" />
              <SocialLink user={linkedin} name="linkedin" />
            </div>
          );
  }
}

SocialLink.propTypes = {
  link: PropTypes.string,
  name: PropTypes.string,
};

Social.propTypes = {
  twitter: PropTypes.string,
  behance: PropTypes.string,
  dribbble: PropTypes.string,
  facebook: PropTypes.string,
  linkedin: PropTypes.string,
};

export { SocialLink };



// WEBPACK FOOTER //
// ./profile/components/social.jsx